import { TaneswPortalMainCargoTracking } from "./TaneswPortalMainCargoTracking";
import { TaneswPortalMainNotification } from "./TaneswPortalMainNotification";
import { TaneswPortalMainExchangeRates } from "./TaneswPortalMainExchangeRates";
import { TaneswPortalMainInformation } from "./TaneswPortalMainInformation";
import { TaneswPortalMainAuctionGoods } from "./TaneswPortalMainAuctionGoods";

const TaneswPortalMain = () => {
    return (
        <div className="flex flex-col gap-4">
            <TaneswPortalMainCargoTracking />
            <div className="grid gap-4 grid-cols-1 lg:grid-cols-12 [&_h2]:font-semibold">
                <div className="lg:col-span-8">
                    <TaneswPortalMainNotification />
                </div>
                <div className="lg:col-span-4">
                    <TaneswPortalMainExchangeRates />
                </div>
                <div className="lg:col-span-8">
                    <TaneswPortalMainInformation />
                </div>
                <div className="lg:col-span-4">
                    <TaneswPortalMainAuctionGoods />
                </div>
            </div>
        </div>
    );
};

export default TaneswPortalMain;
